// Insere o script para a busca por voz
const LoadFloatingBuy = {
  instance: false,
  addFloatingBuyScript: function(){
    const floatingBuyEl = document.querySelector('[data-floating-buy]')

    if (LoadFloatingBuy.instance || !floatingBuyEl || !window.floatingBuyScript || !window.floatingBuyStyle) return

    const styleEl = document.createElement('link');
    styleEl.setAttribute('href', window.floatingBuyStyle);
    styleEl.setAttribute('type', 'text/css');
    styleEl.setAttribute('rel', 'stylesheet');
    document.body.appendChild(styleEl);

    let newScript = document.createElement('script');
    newScript.setAttribute('src', window.floatingBuyScript);
    document.body.appendChild(newScript);
    console.log('Script da Compra Flutuante adicionado!')

    LoadFloatingBuy.instance = true
  },
  init: function(){
    window.addEventListener('mousemove', this.addFloatingBuyScript, { once: true });
    window.addEventListener('scroll', this.addFloatingBuyScript, { once: true });
  }
}

export default LoadFloatingBuy;
